import { DefaultColors } from './Theme/DefaultColors';

export type ColorPairs = [string, string];

export const characterWriterColorPairs: ColorPairs[] = [
  [DefaultColors.red.CC_ARROW_PINK, DefaultColors.red.CC_LIGHT_RED],
  [DefaultColors.orange.CC_ARROW_ORANGE, DefaultColors.orange.CC_LIGHT_ORANGE],
  [DefaultColors.yellow.CC_ARROW_YELLOW, DefaultColors.yellow.CC_LIGHT_YELLOW],
  [DefaultColors.green.CC_ARROW_GREEN, DefaultColors.green.CC_LIGHT_GREEN],
  [DefaultColors.blue.CC_ARROW_LIGHT_BLUE, DefaultColors.blue.CC_LIGHT_BLUE],
  [DefaultColors.purple.CC_ARROW_PURPLE, DefaultColors.purple.CC_LIGHT_PURPLE],
  [DefaultColors.red.CC_ARROW_RED, DefaultColors.red.CC_LIGHT_RED],
  ['#FF974D', '#FFF2EB'],
  ['#FAED00', '#FDFFE3'],
  ['#6CD962', '#FFF2EB'],
  [
    DefaultColors.cyan.CC_UNFILLED_CYAN,
    DefaultColors.cyan.CC_UNFILLED_LIGHT_CYAN,
  ],
  [
    DefaultColors.blue.CC_UNFILLED_BLUE,
    DefaultColors.blue.CC_UNFILLED_LIGHT_BLUE,
  ],
  [
    DefaultColors.red.CC_UNFILLED_PINK,
    DefaultColors.red.CC_UNFILLED_LIGHT_PINK,
  ],
];

export const DefaultPicNormalColor = [
  { backgroundColor: '#ffe0e8', borderColor: DefaultColors.red.CC_PINK },
  { backgroundColor: '#ffe7c7', borderColor: '#fdc970' },
  { backgroundColor: '#fff5c7', borderColor: DefaultColors.yellow.CC_YELLOW },
  { backgroundColor: '#def7d9', borderColor: DefaultColors.green.CC_GREEN },
  { backgroundColor: '#c7edff', borderColor: DefaultColors.blue.CC_BLUE },
  { backgroundColor: '#f1e0ff', borderColor: DefaultColors.purple.CC_PURPLE },
];

export const DefaultPicColorRanges: ColorPairs[] = [
  ['#f9bfd0', '#ca5d86'],
  ['#f1bf79', '#e2a352'],
  ['#f7d56c', '#dfe92b'],
  ['#adce8e', '#709a35'],
  ['#7eceed', '#43a2c8'],
  ['#d8b9ec', '#89639b'],
  ['#d3abcc', '#c98ec3'],
  ['#e99f92', '#cf6758'],
  ['#ccd18d', '#aba83a'],
  ['#6acac0', '#36aa98'],
  ['#a2ade4', '#5d70b5'],
];
